<template>
  <input type="file" name="fileUpload" :accept="accept" @change="onFileChange" />
</template>

<script>
import { Errors } from '@/enums/errors.enum';
import { fileLimitsMixin } from '@/mixins/fileLimits';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Zmodyfikowana kopia pluginu od uploadu plików
// https://github.com/saivarunk/vue-simple-upload
// @group formComponents
export default {
  mixins: [notificationsMixin, fileLimitsMixin],

  props: {
    // Adres uploadu
    target: { type: String },
    // Rodzaj akcji
    action: { type: String, default: 'POST' },
    // Nazwa pola na plik
    alias: { type: String, default: 'file' }
  },
  methods: {
    // @vuese
    // Notyfikuje o postępie uploadu
    uploadProgress(oEvent) {
      if (oEvent.lengthComputable) {
        const percentComplete = Math.round((oEvent.loaded * 100) / oEvent.total);
        this.$emit('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        this.$emit('progress', 0);
      }
    },
    // @vuese
    // Pobiera ciasteczko
    getCookie: function(name) {
      const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      const arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      }
      return null;
    },
    // @vuese
    // Obsługa uploadu
    onFileChange(e) {
      if (!this.target) {
        throw new Error('Please provide the target url');
      }
      if (!this.action) {
        throw new Error('Please provide file upload action ( POST / PUT )');
      }
      if (this.action !== 'POST' && this.action !== 'PUT') {
        throw new Error('File upload component only allows POST and PUT Actions');
      }

      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      const file = files[0];

      if (this.maxSize && file.size > this.maxSize) {
        this.notifyError(Errors.FILE_SIZE_TOO_BIG);
        return;
      }

      const types = this.accept?.split(',').map(type => type.trim());

      if (types?.length && !types.some(type => file.type === type || file.name.endsWith(type))) {
        this.notifyError(Errors.FILE_TYPE_NOT_ACCEPTED);
        return;
      }

      const formData = new FormData();
      formData.append(this.alias, file);
      const xhr = new XMLHttpRequest();
      xhr.open(this.action, this.target);

      xhr.setRequestHeader('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));

      xhr.onloadstart = e => this.$emit('start', e);
      xhr.onloadend = e => {
        if (e.target.status < 400) {
          this.$emit('finish', e);
        } else {
          this.$emit('error', e);
        }
      };
      xhr.onerror = e => this.$emit('emit', e);
      xhr.upload.onprogress = e => this.uploadProgress(e);

      xhr.send(formData);
    }
  }
};
</script>
